export default {
  loadBtn: false,

  socialNetworks: [],
  
  date:{},

  language: [],

  changeLanguage: false,

  menuPosition: [],

  headerMenu: [],

  footerMenu: [],

  config: [],

  aboutUs: [],

  contactUs: [],

  captcha: {},

  categories: [],

  blogs: [],
  blog: {},

  comments: [],
  commentsLength: [],

  medias: [],
  media: {},
  mediaGallery: {},

  mediaComments: [],
  mediaCommentsLength: [],

  photos: [],
  photo: {},
  photosGallery: {},

  photoComments: [],
  photoCommentsLength: [],

  books: [],
  bookGallery: {},

  bookComments: [],
  bookCommentsLength: [],

  publishers: [],

  authors: [],

  sounds: [],
  sound: [],
  soundGallery: {},

  soundComments: [],
  soundCommentsLength: [],

  bookContents: [],

  bookDetails: [],

  bookPublisher: [],

  search: [],
};
